import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DevAuthService } from 'src/app/core/auth/dev-auth.service';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-unauthorized',
    template: `
    <ion-content class="ion-text-center">
      <div class="center">
        <ion-icon name="lock-closed-outline" style="font-size:3rem; color:var(--ink-muted)"></ion-icon>
        <p>{{ 'unauthorized.message' | translate }}</p>
        <ion-button (click)="auth.login()">{{ 'unauthorized.login' | translate }}</ion-button>
      </div>
    </ion-content>
  `,
    styles: [`.center { display:flex; flex-direction:column; align-items:center; justify-content:center; height:100%; gap:1rem; padding:2rem; text-align:center; }`],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, TranslatePipe],
})
export class UnauthorizedComponent {
  constructor(public auth: DevAuthService) { }
}
